import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { ANY_ERROR } from "../../../../action/user_action_types";
import { getServerDataWithTypes } from "../../../../action/common_action";
import {
  CLUSTER_LIST,
  STATE_LIST,
} from "../../../../action/salesUser_action_types";

import SideBar from "../../common/sideBar";
import { history } from "../../../../history/history";
import Pagination from "../../../common/Pagination";
import { endPoints } from "../../../../config";
import NoData from "../../common/NoData";
import http from "../../../../util/http";
import moment from "moment";

import HeaderAdminpanel from "../../common/HeaderAdminpanel";
import { CommonModelImpl } from "../../../admin/common/CommonModel";
import { axiosInstnace as Axios } from "../../../../util/util";
import ViewCluster from "./viewCluster";

class Clusterlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      totalRecords: 0,
      clusterData: [],
      // adminData: getAdminData()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // check whether client has changed
    if (prevProps.client !== this.props.client) {
      this.fetchData(this.props.clusterData);
    }
  }

  //Set data of admin to state
  componentWillReceiveProps = (nextProps) => {
    console.log(nextProps);
    let { clusterList } = nextProps;
    if (clusterList) {
      let { allData, count } = clusterList;
      this.setState({
        clusterData: allData ? allData : [],
        totalRecord: count ? count : 0,
      });
    }
  };

  componentDidMount = () => {
    this.getAllStates();
  };

  getAllStates = async () => {
    this.props.getStateList(`${endPoints.getStateList}`, STATE_LIST);
    this.props.getClusterList(`${endPoints.getClusters}`, CLUSTER_LIST);
    // const response = await Axios.get(`${endPoints.getClusters}`);
    // console.log(response)
  };

  getAllcityandstate = async () => {
    this.props.getStateList(`${endPoints.getStateList}`, STATE_LIST);
    this.props.getCityList(`${endPoints.getCityList}`, CITY_LIST);
  };

  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      this.componentDidMount();
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };

  //Redirect to route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Return the table for sales user
  render() {
    let { clusterData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="dashboardContainer">
        <HeaderAdminpanel />

        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>

          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                System Configuration |
                <span className="breadcrumb-active fct-breadcrumb">
                  Cluster List
                </span>
              </div>
              <div className="search_camp">
                <button
                  onClick={() =>
                    this.goToRoute("", null, "/admin/clusterlist/addCluster")
                  }
                  className="search_camp_btn"
                >
                  ADD
                </button>
              </div>
            </div>

            <div
              className={
                clusterData.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Create By</th>
                    {/* <th>created At</th>      */}
                    <th>Actions</th>
                    <th>Trade Partners</th>
                  </tr>
                </thead>
                <tbody>
                  {clusterData.map((cluster, index) => {
                    indexNum++;
                    return (
                      <tr key={index}>
                        <td>{indexNum}</td>
                        <td>{cluster.name}</td>
                        <td>{cluster.email}</td>
                        {/* <td>{moment(cluster.createdAt).format("DD/MM/YYYY HH:mm:A")}</td>   */}

                        <td className="txt-cntr">
                          <a>
                            <span className="tooltip-reject view-tooltip">
                              <img
                                src="/assets/images/eye.png"
                                className="reject-approved-img reject-png"
                                onClick={() => {
                                  this.goToRoute(
                                    "clusterData",
                                    { cluster },
                                    "/admin/clusterlist/clusterView"
                                  ),
                                    this.getAllcityandstate;
                                  // this.props.clusterData(cluster)
                                }}
                              />
                              <span>View</span>
                            </span>
                          </a>
                          <a>
                            <span className="tooltip-reject">
                              <img
                                src="/assets/images/edit-1.png"
                                className="edit-img-icon reject-png"
                                onClick={() => {
                                  this.goToRoute(
                                    "clusterData",
                                    { cluster },
                                    "/admin/clusterlist/clusterEdit"
                                  ),
                                    this.getAllcityandstate;
                                  // this.props.clusterData(cluster)
                                }}
                              />
                              <span>Edit</span>
                            </span>
                          </a>
                        </td>
                        <td    onClick={() => {
                                  this.goToRoute(
                                    "tradepartners",
                                    { cluster: cluster.name },
                                    "/admin/tp"
                                  )}}>{cluster.tradepartners.length}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="paginationTable">
                {/* {totalRecords > 10 &&
                <Pagination getAllData={this.getClusters} totalRecords={totalRecords} />
              } */}
              </div>
            </div>
            {clusterData.length === 0 ? <NoData /> : null}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    stateList: state.sales.get("stateList"),
    clusterList: state.sales.get("clusterList"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    getStateList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
    getClusterList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Clusterlist);

//http://localhost:3000/admin/salesuser/clusterlist



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/Clusterlist.jsx